<template>
  <div class="paySlip-container">
    <div class="paySlip-header">
      <img @click="handleBack" class="back_white" src="../assets/back_white.png" />
      <img class="dollor" src="../assets/dollor.png" />
      <div class="net-salary">实发工资</div>
      <div class="net-number">{{`¥${renderRealSalary()}`}}</div>
    </div>
    <div class="paySlip-content">
      <div class="net-li">
        <span>月份</span>
        <span>{{data.year + '.' + data.month}}</span>
      </div>
      <div class="net-li">
        <span>公司</span>
        <span>{{data.companyName}}</span>
      </div>
      <div class="net-li" v-for="(item) in salary" :key="item.sort">
        <span>{{item.fieldName}}</span>
        <span>{{renderValue(item)}}</span>
      </div>
      <div class="net-li" v-for="(item) in meritPay" :key="item.sort">
        <span>{{item.fieldName}}</span>
        <span>{{renderValue(item)}}</span>
      </div>
      <!-- <div class="net-li">
        <span>绩效系数</span>
        <span>{{data.perfCoe}}</span>
      </div>
      <div class="net-li">
        <span>绩效等级</span>
        <span>{{data.perfLevel}}</span>
      </div>
      <div class="net-li">
        <span>实发绩效</span>
        <span>{{data.realPerf}}</span>
      </div>
      <div class="net-li" v-for="(item) in subsidy" :key="item.sort">
        <span>{{item.fieldName}}</span>
        <span>{{renderValue(item)}}</span>
      </div>
      <div class="net-li">
        <span>应发工资</span>
        <span>{{data.shouldSalary}}</span>
      </div>
      <div class="net-li" v-for="(item) in SubsidiesPayable" :key="item.sort">
        <span>{{item.fieldName}}</span>
        <span>{{renderValue(item)}}</span>
      </div>
      <div class="net-li" v-for="(item) in Deduction" :key="item.sort">
        <span>{{item.fieldName}}</span>
        <span>{{renderValue(item)}}</span>
      </div>
      <div class="net-li">
        <span>个人承担社保</span>
        <span>{{data.personalSi}}</span>
      </div> -->
      <!-- <div class="net-li">
        <span>公司承担社保</span>
        <span>{{data.firmSi}}</span>
      </div> -->
      <!-- <div class="net-li">
        <span>个人承担公积金</span>
        <span>{{data.personalFund}}</span>
      </div> -->
      <!-- <div class="net-li">
        <span>公司承担公积金</span>
        <span>{{data.firmFund}}</span>
      </div> -->
      <!-- <div class="net-li">
        <span>个税</span>
        <span>{{data.tax}}</span>
      </div>
      <div class="net-li">
        <span>考勤扣款</span>
        <span>{{data.attendanceDeduction}}</span>
      </div> -->
      <!-- <div class="net-li" v-for="(item,index) in dynamicList" :key="index">
        <span>{{item.fieldName}}</span>
        <span>{{renderValue(item)}}</span>
      </div> -->
      <!-- <div class="net-li">
        <span>实发工资</span>
        <span>{{data.realSalary}}</span>
      </div> -->
    </div>
    
    <div class="confirm-btn" @click="handleOk" v-if="data.status !== 1"> 签名确认</div>
    <van-popup v-if="show" v-model="show" closeable>
      <Autograph @showModal="showModal" :recordId="data.recordId" />
    </van-popup>
  </div>
</template>

<script>
import { queryPay } from '../axios/services'
import Autograph from './Autograph.vue'
import { mapState } from 'vuex'
export default {
  components: {
    Autograph
  },
  data() {
    return {
      net: '¥999349.00',
      show: false,
      dynamicList: [],
      data: {},
      subsidy:[],//其他补贴
      salary:[],//标准薪资
      meritPay:[],//绩效工资
      additional:[],//额外扣除
      SubsidiesPayable:[],//应发后补助
      Deduction:[],//应发后扣款
    }
  },
  computed: {
    ...mapState(['initialData', 'payDate'])
  },
  created() {
    const params = {
      companyId: this.initialData.companyId,
      year: this.payDate.year,
      month: this.payDate.month
    }
    queryPay(params).then(res => {
      if(res.data.code === 0) {
        this.dynamicList = res.data.data.recordData
        console.log(this.dynamicList);
         this.dynamicList.filter(item=>{
              if (item.type==0) {
                this.salary.push(item)
              }
              if (item.type==1) {
                this.subsidy.push(item)
              }
              if (item.type==2) {
                this.meritPay.push(item)
              }
              if (item.type==3) {
                this.additional.push(item)
              }
              if (item.type==4) {
                this.SubsidiesPayable.push(item)
              }
              if (item.type==5) {
                this.Deduction.push(item)
              }
            })
        this.data = res.data.data
      }
    })
  },
  methods: {
    handleOk() {
      this.show = true
    },
    showModal() {
      this.show = !this.show
    },
    handleBack() {
      this.$router.push('/pay-list')
    },
    renderValue(item) {
      return item.structureValue ? item.structureValue : 0
    },
    renderRealSalary() {
      const value = this.data.recordData?.slice(-1)[0].structureValue
      return value ? value : 0
    },
  }
}
</script>

<style scoped>
  .paySlip-container {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: auto ;
    padding-bottom: 1.2rem;
    padding-top: 5.28rem;
  }
  .paySlip-header {
    width: 100%;
    height: 5.28rem;
    background: url('../assets/pay_slip_bg.png');
    position: fixed;
    top: 0;
    left: 0;
  }
  .back_white {
    width: 0.35rem;
    height: 0.59rem;
    position: absolute;
    left: 0.37rem;
    top: 0.83rem;
  }
  .dollor {
    width: 1.01rem;
    height: 1.28rem;
    position: absolute;
    top: 1.49rem;
    left: 50%;
    transform: translateX(-50%);
  }
  .net-salary {
    width: 1.72rem;
    height: 0.59rem;
    font-size: 0.43rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.59rem;
    position: absolute;
    top: 3.15rem;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
  }
  .net-number {
    width: 3.95rem;
    height: 0.99rem;
    font-size: 0.69rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 0.99rem;
    position: absolute;
    top: 3.76rem;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
  }
  .paySlip-content {
    width: 9.25rem;
    background: #FFFFFF;
    border-radius: 0.21rem;
    margin: 0.53rem auto;
  }
  .net-li {
    width: 9.25rem;
    height: 1.17rem;
    padding: 0.43rem;
    padding-top: 0.32rem;
    display: flex;
    justify-content: space-between;
  }
  .confirm-btn {
    width: 8.29rem;
    height: 1.17rem;
    background: #1584FF;
    box-shadow: 0rem 0.05rem 0.21rem 0rem #80BCFF;
    border-radius: 0.21rem;
    position: fixed;
    left: 0.85rem;
    bottom: 0.32rem;
    font-size: 0.43rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 1.17rem;
    text-align: center;
  }
</style>